import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, setToken, formatError } from "@/lib/api";
import { IMAGES } from "@/lib/content";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img src={IMAGES.logo} alt="E2E" className="h-14" />
        </div>
        <div className="border border-white/12 p-10">
          <div className="flex items-center gap-2 text-[#D4AF37] mb-8">
            <Lock size={15} />
            <span className="font-body text-xs tracking-[0.28em] uppercase">Admin Access</span>
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="flex flex-col gap-2">
              <label className="font-body text-xs tracking-[0.2em] uppercase text-white/50">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="bg-black border border-white/25 text-white px-4 py-3.5 font-body focus:outline-none focus:border-[#D4AF37] transition-colors"
                placeholder="you@employee2employer.com"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="font-body text-xs tracking-[0.2em] uppercase text-white/50">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="bg-black border border-white/25 text-white px-4 py-3.5 font-body focus:outline-none focus:border-[#D4AF37] transition-colors"
                placeholder="••••••••"
              />
            </div>
            {error && <p className="font-body text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-[#D4AF37] hover:bg-[#E6C75A] text-black font-body font-medium py-4 transition-colors duration-300 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <p className="font-body text-xs text-white/30 text-center mt-6">
          Employee 2 Employer · Builder Platform
        </p>
      </div>
    </div>
  );
}
